import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function EditProfile() {
  const navigate = useNavigate();

  const storedUsername = localStorage.getItem("spectraUser") || "";
  const storedEmail = localStorage.getItem("spectraEmail") || (storedUsername ? `${storedUsername}@spectra.local` : "");

  const [formData, setFormData] = useState({
    username: storedUsername,
    email: storedEmail
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    localStorage.setItem("spectraUser", formData.username);
    localStorage.setItem("spectraEmail", formData.email);
    alert('Profile updated!');
    navigate('/settings');
  };

  return (
    <div style={{ padding: '24px', maxWidth: '600px', margin: '0 auto' }}>
      <h2 style={{ marginBottom: '24px' }}>Edit Profile</h2>

      <div style={{
        background: '#fff',
        padding: '24px',
        borderRadius: '12px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <div style={{ marginBottom: '16px' }}>
          <label style={labelStyle}>Username</label>
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
            style={inputStyle}
          />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={labelStyle}>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            style={inputStyle}
          />
        </div>

        <button style={buttonStyle} onClick={handleSave}>Save Changes</button>
      </div>
    </div>
  );
}

const labelStyle = { display: 'block', marginBottom: '6px', fontWeight: 'bold' };
const inputStyle = {
  width: '100%',
  padding: '12px',
  borderRadius: '6px',
  border: '1px solid #ccc',
  marginBottom: '12px'
};
const buttonStyle = {
  padding: '12px',
  borderRadius: '6px',
  border: 'none',
  background: '#ffd700',
  color: '#111',
  fontWeight: 'bold',
  cursor: 'pointer',
  width: '100%'
};
